import tellUsAboutYourselfApi from '../api/tellUsAboutYourselfApi';
import properyItemModel from '../models/properyItem';
import { CATEGORY_ID } from '../constants/category';

class TellUsAboutYourselfService {
  loadSexTellUsAboutYourSelfData(params) {
    return tellUsAboutYourselfApi
      .loadSexTellUsAboutYourSelfData(params)
      .then(res => {
        if (res.success) {
          let propertyItems = properyItemModel.mappingObjects(res.data.items);
          propertyItems = properyItemModel.getIconObjects(CATEGORY_ID.LTM_LOOKING_FOR, propertyItems);
          res.data.items = propertyItems;
        } else {
          console.log('ERROR: TellUsAboutYourselfService/loadSexTellUsAboutYourSelfData:', res);
        }
        return res;
      })
      .catch(e => {
        console.log('ERROR: TellUsAboutYourselfService/loadSexTellUsAboutYourSelfData:', e);
        throw new Error('failed');
      });
  }

  // todo may be is used in future
  // loadAgeTellUsAboutYourSelfData(params) {
  //
  //   return tellUsAboutYourselfApi.loadSexTellUsAboutYourSelfData(params).then((res) => {
  //     if(res.success){
  //       let categoryData = Object.assign({}, params);
  //       categoryData.contentTabs =[{indexTab: 0, value: new Date()}];
  //       let result = categoryModel.mappingObject(categoryData);
  //       return result;
  //     }
  //     else{
  //       throw ("failed");
  //     }
  //   });
  // }

  loadEthnicityTellUsAboutYourSelfData(params) {
    return tellUsAboutYourselfApi
      .loadEthnicityTellUsAboutYourSelfData(params)
      .then(res => {
        if (res.success) {
          res.data.items = properyItemModel.mappingObjects(res.data.items);
        } else {
          console.log('ERROR: TellUsAboutYourselfService/loadEthnicityTellUsAboutYourSelfData:', res);
        }
        return res;
      })
      .catch(e => {
        console.log('ERROR: TellUsAboutYourselfService/loadEthnicityTellUsAboutYourSelfData:', e);
        throw new Error('failed');
      });
  }
  loadRelationShip() {
    return tellUsAboutYourselfApi
      .loadRelationShip()
      .then(res => {
        if (res.success) {
          res.data.items = properyItemModel.mappingObjects(res.data.items);
        } else {
          console.log('ERROR: TellUsAboutYourselfService/loadRelationShip:', res);
        }
        return res;
      })
      .catch(e => {
        console.log('ERROR: TellUsAboutYourselfService/loadRelationShip:', e);
        throw new Error('failed');
      });
  }

  loadBodyTypesData(params, memberType) {
    return tellUsAboutYourselfApi
      .loadBodyTypesData(params)
      .then(res => {
        if (res.success) {
          let propertyItems = properyItemModel.mappingObjects(res.data.items);
          propertyItems = properyItemModel.getIconObjects(CATEGORY_ID.TU2_BODY_TYPE, propertyItems);
          res.data.items = propertyItems;
        } else {
          console.log('ERROR: TellUsAboutYourselfService/loadBodyTypesData:', res);
        }
        return res;
      })
      .catch(e => {
        console.log('ERROR: TellUsAboutYourselfService/loadBodyTypesData:', e);
        throw new Error('failed');
      });
  }

  loadHeightData(params) {
    return tellUsAboutYourselfApi
      .loadHeightData(params)
      .then(res => {
        if (res.success) {
          res.data.items = properyItemModel.mappingObjects(res.data.items);
        } else {
          console.log('ERROR: TellUsAboutYourselfService/loadHeightData:', res);
        }
        return res;
      })
      .catch(e => {
        console.log('ERROR: TellUsAboutYourselfService/loadHeightData:', e);
        throw new Error('failed');
      });
  }

  loadOrientationData(params, memberType) {
    return tellUsAboutYourselfApi
      .loadOrientationData(params)
      .then(res => {
        if (res.success) {
          res.data.items = properyItemModel.mappingObjects(res.data.items);
        } else {
          console.log('ERROR: TellUsAboutYourselfService/loadOrientationData:', res);
        }
        return res;
      })
      .catch(e => {
        console.log('ERROR: TellUsAboutYourselfService/loadOrientationData:', e);
        throw new Error('failed');
      });
  }
}

export default new TellUsAboutYourselfService();
